import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'notary',
  type: 'node--notary',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    nombre: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nt_nombre',
    },
    apellidos: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'nt_apellidos',
    },
    telefono: {
      type: 'number',
      required: false,
      isArray: false,
      name: 'nt_telefono',
    },
  },
  relationships: {
  },
};

export const NotarioService = createService(base, configuration, API_CONFIG.API);
export const NotarioModule = createModule(NotarioService, true);



// WEBPACK FOOTER //
// ./src/models/notary.js